import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import LookupGeneric from "./lookupGeneric";
import MessageTemplateService from "../../src/Services/MessageTemplate.service";
const MessageTemplateLookup = (props) => {
    return LookupGeneric({
        onChange: props.onChange,
        defaultIds: props.defaultIds,
        fetchItemsById: (ids) => {
            return MessageTemplateService.findByIds(ids);
        },
        fetchOptions: (search) => {
            return MessageTemplateService.searchAll(search);
        },
        optionRenderer: function optionRenderer(messageTemplate) {
            return _jsx("span", { children: messageTemplate.name });
        },
    });
};
export default MessageTemplateLookup;
